module.exports = __webpack_public_path__ + "img/notify3.9df3e3b7.png";